.fade-enter {
  opacity: 0;
  z-index: 1;
}

.fade-enter.fade-enter-active {
  opacity: 1;
  transition: opacity 250ms ease-in;
}

.modal-backdrop {
  background-color: rgba(255, 255, 255, 0.7);
}

.btn-i {
  cursor: pointer;
}

.error-alert {
    text-align: justify;
    max-height: 500px;
    overflow: auto;
    font-size: initial;
    padding-right: 10px;
}

.error-alert li {
    margin-top: 10px;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/assets/css/portal.css
// module id = 795
// module chunks = 0